import { memo } from 'react'
import { CompareItemsTableItemIndicatorCell as TCompareItemsTableItemIndicatorCell } from '../../types'

import useSelectedItems from '../../states/useSelectedItems'

import style from './ItemIndicatorCell.module.scss'

export default memo(
  CompareItemsTableItemIndicatorCell,
  (prevProps, nextProps) =>
    prevProps.width === nextProps.width &&
    prevProps.className === nextProps.className &&
    prevProps.cell === nextProps.cell
)
export function CompareItemsTableItemIndicatorCell({
  className,
  width,
  cell
}: {
  className: string
  width: number
  cell: TCompareItemsTableItemIndicatorCell
}) {
  const selectedItems = useSelectedItems()

  const reactiveColStyle = cell.canRemove
    ? `
    div[data-compare-items="root"]:has(div[data-compare-items-header-col="${cell.col}"]:hover)
    div.${style.CompareItemsTableItemIndicatorCell}[data-compare-items-header-col="${cell.col}"] 
    .${style.removeItem} {
      display: block;
    }
  `
    : ''

  return (
    <div
      className={`${className || ''} ${style.CompareItemsTableItemIndicatorCell}`}
      style={{ flex: `0 0 ${width}px`, width: `${width}px` }}
      data-compare-items="indicator-cell"
      data-compare-items-header-col={cell.col}
    >
      {null != cell.rank ? (
        <div className={style.rank} style={{ background: cell.color }}>
          {cell.rank}
        </div>
      ) : null}
      {cell.canRemove ? (
        <>
          <style>{reactiveColStyle}</style>
          <div
            className={style.removeItem}
            title={`remove ${cell.itemName || 'item'}`}
            onClick={() => void selectedItems.removeItem(cell.index)}
          >
            +
          </div>
        </>
      ) : null}
    </div>
  )
}
